/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileVector16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M5.195 6.07l.005.01c.12.312.292.6.504.851l-.424.254c-1.414.847-2.452 2.33-2.715 3.992a1 1 0 11-.999-.078c.289-1.994 1.516-3.763 3.2-4.772l.43-.257zm5.618.003l.429.256c1.687 1.008 2.91 2.77 3.197 4.77a1 1 0 11-1.002.074c-.26-1.665-1.293-3.14-2.708-3.986l-.43-.256.013-.019c.194-.235.354-.5.47-.787l.03-.052zM8 3a2 2 0 011.937 1.5h4.592c.26 0 .471.21.471.47v.06c0 .26-.21.47-.47.47l-4.593.001a2.001 2.001 0 01-3.874 0L1.471 5.5a.47.47 0 01-.47-.47v-.06c0-.26.21-.47.47-.47h4.592A2 2 0 018 3zm0 1a1 1 0 00-1 .98v.039l.007.098A1 1 0 108 4z"
        />
    </AccessibleSVG>
);

export default FileVector16;
